import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PartnerAccountPayoutEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class PartnerAccountPayoutContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, payoutPlanId, partnerId, country } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          Edit Payout Plan
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>

        <PartnerAccountPayoutEditor
          t={t}
          country={country}
          partnerId={partnerId}
          seletedPayoutPlanId={payoutPlanId}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PartnerAccountPayoutContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PartnerAccountPayoutContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default PartnerAccountPayoutContainer;
